import React from 'react'
import { Box, Typography, Divider, List, ListItemIcon, ListItem, ListItemText } from '@mui/material'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import BusinessIcon from '@mui/icons-material/Business'
import FactCheckIcon from '@mui/icons-material/FactCheck'
import InventoryIcon from '@mui/icons-material/Inventory'
import AutoGraphIcon from '@mui/icons-material/AutoGraph'
import BallotIcon from '@mui/icons-material/Ballot'
import CasinoIcon from '@mui/icons-material/Casino'
import FlightIcon from '@mui/icons-material/Flight'
import LoyaltyIcon from '@mui/icons-material/Loyalty'
import {
  HTL_STOCK,
  ECO_STOCK,
  SALES_STATS,
  TLP_POINT,
  TRIP_POINT,
  NEXEN_POINT,
  HTS_POINT_SYSTEM,
  TYREHUB_POINT,
  BATTERY_INCENTIVE_POINT,
  MOBIL_NORTH_CHINA_TRIP_POINT,
  FIESTA_POINT,
  CP58,
  HTG_INCENTIVE,
  HTG_INCENTIVE_ADMIN,
  WHATSAPP_BROADCAST,
  HTL_2026,
  SALES_COMMISSION_INCENTIVE,
  CNN_POINT,
  CNN_ADMIN,
  GMN_POINT,
  GMN_ADMIN,
  LUCKY_DRAW_ADMIN,
} from '../../constant/permission'
import { isStaging, isProduction } from '../../utils/getEnvironment'
import { useGetBillingAccess, useGetTyrehubAccess, useGetAccountAccess } from '../../api/user'
import MonetizationOnIcon from '@mui/icons-material//MonetizationOn'
import RequestPageIcon from '@mui/icons-material/RequestPage'

export const ApplicationLinksCard = (props) => {
  const { permission } = props

  const { data: hasBillingAccess } = useGetBillingAccess()

  const { data: hasTyrehubAccess } = useGetTyrehubAccess()

  const { data: hasAccountAccess } = useGetAccountAccess()

  const applicationlinks = [
    // {
    //   itemText: 'Staff Benefits',
    //   url: '/user-staff-benefit',
    //   icon: <LoyaltyIcon />,
    //   newTab: false,
    //   hasAccess: true //all staff should access this feature
    // },
    {
      itemText: 'Staff Benefit Portal',
      url: `${
        isProduction()
          ? 'https://htcare.com.my'
          : isStaging()
            ? 'https://stg.htcare.com.my'
            : 'http://localhost:3000'
      }`,
      icon: <LoyaltyIcon />,
      newTab: true,
      hasAccess: true, //all staff should access this feature
    },
    {
      itemText: 'Billing App',
      url: `${
        isProduction()
          ? 'https://billing.htgroup.com.my'
          : isStaging()
            ? 'https://estatementjs-staging.herokuapp.com/'
            : 'http://localhost:3002'
      }`,
      icon: <AccountBalanceIcon />,
      newTab: true,
      hasAccess: hasBillingAccess,
    },
    {
      itemText: 'Accounts App',
      url: `${
        isProduction()
          ? 'https://accounts.htgroup.com.my'
          : isStaging()
            ? 'https://stg.accounts.htgroup.com.my/'
            : 'http://localhost:3003'
      }`,
      icon: <FactCheckIcon />,
      newTab: true,
      hasAccess: hasAccountAccess,
    },
    {
      itemText: 'Automarket',
      url: `${
        isProduction()
          ? 'https://automarket.my'
          : isStaging()
            ? 'https://stg.automarket.my'
            : 'http://localhost:8082'
      }`,
      icon: <BusinessIcon />,
      newTab: true,
      hasAccess: hasTyrehubAccess,
    },
    {
      itemText: 'HTS Point System',
      url: 'https://hts.htgroup.com.my/hts/website/homepage.php',
      icon: <BallotIcon />,
      newTab: true,
      permission: HTS_POINT_SYSTEM,
    },
    {
      itemText: 'HTL Stock List',
      url: '/htl-stocklist',
      icon: <InventoryIcon />,
      newTab: false,
      permission: HTL_STOCK,
    },
    {
      itemText: 'ECO Stock List',
      url: '/eco-stocklist',
      icon: <InventoryIcon />,
      newTab: false,
      permission: ECO_STOCK,
    },
    {
      itemText: 'Revenue Dashboard',
      url: '/revenue-dashboard',
      icon: <AutoGraphIcon />,
      newTab: false,
      permission: SALES_STATS,
    },
    {
      itemText: 'Mobil TLP Point Panel',
      url: '/tlp-point',
      icon: <BallotIcon />,
      newTab: false,
      permission: TLP_POINT,
    },
    {
      itemText: 'Mobil China Trip Point 2.0 Panel',
      url: '/trip-point',
      icon: <FlightIcon />,
      newTab: false,
      permission: TRIP_POINT,
    },
    {
      itemText: 'Mobil North China Trip Point Panel',
      url: '/mobil-north-china-trip-point',
      icon: <FlightIcon />,
      newTab: false,
      permission: MOBIL_NORTH_CHINA_TRIP_POINT,
    },
    {
      itemText: 'HTL 2026 Point Panel',
      url: '/htl-2026-point',
      icon: <FlightIcon />,
      newTab: false,
      permission: HTL_2026,
    },
    {
      itemText: 'Nexen Point Panel',
      url: '/nexen-point',
      icon: <BallotIcon />,
      newTab: false,
      permission: NEXEN_POINT,
    },
    {
      itemText: 'Nexen Trip Point Panel',
      url: '/nexen-trip-point',
      icon: <BallotIcon />,
      newTab: false,
      permission: NEXEN_POINT,
    },
    {
      itemText: 'Tyrehub Trip Point Panel',
      url: '/tyrehub-trip-point',
      icon: <BallotIcon />,
      newTab: false,
      permission: TYREHUB_POINT,
    },
    {
      itemText: 'Battery Incentive Point Panel',
      url: '/battery-incentive-point',
      icon: <BallotIcon />,
      newTab: false,
      permission: BATTERY_INCENTIVE_POINT,
    },
    {
      itemText: 'Fiesta Point Panel',
      url: '/fiesta-point',
      icon: <BallotIcon />,
      newTab: false,
      permission: FIESTA_POINT,
    },
    {
      itemText: 'Sales Comission Incentive',
      url: '/sales-comission-incentive',
      icon: <MonetizationOnIcon />,
      newTab: false,
      permission: SALES_COMMISSION_INCENTIVE,
    },
    {
      itemText: 'CP58',
      url: '/cp-58',
      icon: <RequestPageIcon />,
      newTab: false,
      permission: CP58,
    },
    {
      itemText: 'HTG Incentive Panels',
      url: '/htg-incentive-point',
      icon: <BallotIcon />,
      newTab: false,
      permission: HTG_INCENTIVE,
    },
    {
      itemText: 'HTG Incentive Admin',
      url: '/htg-incentive-admin',
      icon: <BallotIcon />,
      newTab: false,
      permission: HTG_INCENTIVE_ADMIN,
    },
    {
      itemText: 'Whatsapp Broadcast',
      url: '/whatsapp-broadcast',
      icon: <BallotIcon />,
      newTab: false,
      permission: WHATSAPP_BROADCAST,
    },
    {
      itemText: 'HT Connect Admin',
      url: '/ht-connect',
      icon: <BallotIcon />,
      newTab: false,
      permission: CNN_ADMIN,
    },
    {
      itemText: 'HT Connect Point',
      url: '/ht-connect/points',
      icon: <BallotIcon />,
      newTab: false,
      permission: CNN_POINT,
    },
    {
      itemText: 'Golden Moon Night Admin',
      url: '/gmn',
      icon: <BallotIcon />,
      newTab: false,
      permission: GMN_ADMIN,
    },
    {
      itemText: 'Golden Moon Night Point',
      url: '/gmn/points',
      icon: <BallotIcon />,
      newTab: false,
      permission: GMN_POINT,
    },
    {
      itemText: 'Lucky Draw Admin',
      url: '/lucky-draw',
      icon: <CasinoIcon />,
      newTab: false,
      permission: LUCKY_DRAW_ADMIN,
    },
  ]

  //permission logic
  // let allowLinks = []
  // applicationlinks.map((link) => {
  //   if (permission.includes(link.permission)) {
  //     allowLinks.push(link)
  //   }
  // })

  let allowLinks = []
  applicationlinks.map((link) => {
    if (permission.includes(link.permission) || link.hasAccess) {
      allowLinks.push(link)
    }
  })

  const hasLinks = allowLinks.length > 0

  return (
    <Box
      bgcolor='#fff'
      borderRadius={3}
      display={hasLinks ? 'flex' : 'none'}
      width='100%'
      height='100%'
    >
      <Box display='flex' width='100%' flexDirection='column' p={5}>
        <Typography variant='h6'>Applications</Typography>
        <Divider />
        <List>
          {allowLinks
            .sort((a, b) => a.itemText.localeCompare(b.itemText))
            .map((link) => (
              <ListItem
                button
                component='a'
                href={link.url}
                target={link.newTab ? '_blank' : ''}
                key={link.itemText}
              >
                <ListItemIcon sx={{ color: '#999999' }}>{link.icon}</ListItemIcon>
                <ListItemText>{link.itemText}</ListItemText>
              </ListItem>
            ))}
        </List>
      </Box>
    </Box>
  )
}
